import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { SubentityState } from 'app/projects/subentity/src/lib/models/subentity.state';
import { map } from 'rxjs/operators';
import { FetchUserCourseCertificates, FetchUserCourseCertificatesFailure, FetchUserCourseCertificatesSuccess, SetUserCourseCertificates } from '../actions';
import { CertificateRecordApiService } from '../services/certificate-record.api-service';
import { CertificateRecord } from './certificate-record';
import { UserCourseCertificateState } from './user-course-certificate.state';
import { UserCourseCertificatesStateModel } from './user-course-certificates.state-model';

@State<UserCourseCertificatesStateModel>({
    name: 'userCourseCertificates',
    defaults: new UserCourseCertificatesStateModel(),
})
@Injectable()
export class UserCourseCertificatesState extends SubentityState<CertificateRecord> {
    @Selector([UserCourseCertificateState.getEntities])
    static getFilteredEntities(state: UserCourseCertificatesStateModel, providers: CertificateRecord[]): CertificateRecord[] {
        if (!providers) {
            return null;
        }

        return providers
            .filter((item) => state.filtered.indexOf(item.id) !== -1)
            .map((item) => {
                return [state.list.indexOf(item.id), item];
            })
            .sort((a: [number, CertificateRecord], b: [number, CertificateRecord]) => {
                return a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0;
            })
            .map((x: [number, CertificateRecord]) => x[1]);
    }

    @Selector()
    static getTotalCount(state: UserCourseCertificatesStateModel): number {
        return state.totalCount;
    }

    constructor(private store: Store, private _certificateRecordService: CertificateRecordApiService) {
        super(null, 0);
    }

    @Action(FetchUserCourseCertificates)
    fetchAll(ctx: StateContext<UserCourseCertificatesStateModel>, action: FetchUserCourseCertificates): void {
        ctx.patchState({
            pageSize: action.payload.pageSize,
            pageNumber: action.payload.pageNumber,
        });

        this._fetchSubentities(
            ctx,
            { payload: 'all' },
            SetUserCourseCertificates,
            FetchUserCourseCertificatesSuccess,
            FetchUserCourseCertificatesFailure,
            this._certificateRecordService
                .getUserCourseCertificates(
                    action.payload.pageSize,
                    action.payload.pageNumber,
                    action.payload.search,
                    action.payload.userId,
                    action.payload.sortBy,
                    action.payload.sortOrder
                )
                .pipe(
                    map((data) => {
                    ctx.patchState({
                        totalCount: data.pagination.number_of_results,
                    });

                    return data.data.map((query) => new CertificateRecord(query));
                    })
                )
        );
    }

    @Action(FetchUserCourseCertificatesSuccess)
    fetchAllSuccess(ctx: StateContext<UserCourseCertificatesStateModel>): void {
        this._fetchSubentitiesSuccess(ctx);
    }

    @Action(FetchUserCourseCertificatesFailure)
    fetchAllFailure(ctx: StateContext<UserCourseCertificatesStateModel>): void {
        this._fetchSubentitiesFailure(ctx);
    }

    @Action(SetUserCourseCertificates)
    setEntities(ctx: StateContext<UserCourseCertificatesStateModel>, action: SetUserCourseCertificates): void {
        this._setSubentities(ctx, action, null);
    }
}
